import React, { useCallback, useState } from 'react';
import { ChevronRight, Landmark, Plus } from 'lucide-react';
import { loadBillingProfiles } from './api';
import { BillingProfileModal } from './XomicsCustomer';
import { Empty, Failed, Head, Loading, Pill } from './parts';
import { useLiveResource } from './useLive';
import { tx } from './i18n';
import './organizations.css';

const text = (key, values) => tx(`ui.customers.${key}`, values);

// Our billing profiles, under Finance: the companies our invoices are issued by, each with its bank
// accounts (one for each currency customers pay it in). An invoice is billed by one of them, chosen
// when it is made. A profile opens as a form over the page; a new one too. Those in use come first.
export default function XomicsBillingProfiles() {
  const load = useCallback(() => loadBillingProfiles(), []);
  const resource = useLiveResource(['organizations'], load);
  // The form open: undefined when none, null for a new profile, or the profile changed.
  const [editing, setEditing] = useState(undefined);
  const data = resource.data;
  return <div className="xo-products-page xo-org-page">
    <Head title={text('billing_profiles_title')} subtitle={text('billing_profiles_subtitle')}>
      {data !== null && <button type="button" className="xo-btn" onClick={() => setEditing(null)}><Plus aria-hidden="true" />{text('new_profile')}</button>}
    </Head>
    {resource.error ? <Failed message={resource.error} onRetry={resource.refresh} /> : data === null ? <Loading label={text('loading')} />
      : data.profiles.length === 0 ? <Empty title={text('no_profiles')} detail={text('no_profiles_hint')} />
        : <ul className="xo-org-list">{data.profiles.map((profile) => <li key={profile.id}>
          <button type="button" onClick={() => setEditing(profile)} aria-label={profile.legalName}>
            <span className="xo-org-icon"><Landmark aria-hidden="true" /></span>
            <span className="xo-org-identity"><strong>{profile.legalName}</strong>
              {(profile.vatNumber || profile.registrationNumber) && <code>{profile.vatNumber || profile.registrationNumber}</code>}</span>
            <span className="xo-org-type">{profile.city} · {profile.countryCode}</span>
            <span className="xo-org-contact">{profile.email}</span>
            <span className="xo-org-count">{profile.bankAccounts.length === 0 ? text('no_bank_accounts')
              : text('profile_currencies', { currencies: profile.bankAccounts.map((account) => account.currency).join(', ') })}</span>
            <Pill tone={profile.isActive ? 'ok' : 'flat'}>{text(profile.isActive ? 'profile_in_use' : 'profile_not_in_use')}</Pill>
            <ChevronRight aria-hidden="true" />
          </button>
        </li>)}</ul>}
    {editing !== undefined && data !== null && <BillingProfileModal profile={editing} currencies={data.currencies}
      onClose={() => setEditing(undefined)} onSaved={() => { setEditing(undefined); resource.refresh(); }} />}
  </div>;
}
